// eslint-disable-next-line import/prefer-default-export
export const lineChartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  tooltip: {
    shared: true,
    theme: 'dark',
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'smooth',
  },
  xaxis: {
    type: 'datetime',
    categories: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    labels: {
      style: {
        colors: '#fff',
        fontSize: '12px',
      },
    },
  },
  yaxis: [{
    labels: {
      style: {
        colors: '#fff',
        fontSize: '12px',
      },
    },
    title: {
      text: 'Submissions',
      style: {
        color: '#fff',
        fontSize: '12px',
      },
    },
    min: 0,
  }, {
    opposite: true,
    labels: {
      style: {
        colors: '#fff',
        fontSize: '12px',
      },
    },
    title: {
      text: 'Views',
      style: {
        color: '#fff',
        fontSize: '12px',
      },
    },
    min: (min) => (min < 10 ? 0 : Math.floor(min * 0.9)),
  }],
  legend: {
    show: false,
  },
  grid: {
    strokeDashArray: 5,
  },
  fill: {
    type: 'gradient',
    gradient: {
      shade: 'light',
      type: 'vertical',
      shadeIntensity: 0.5,
      inverseColors: true,
      opacityFrom: 0.8,
      opacityTo: 0,
      stops: [],
    },
    colors: ['#fff', '#3182CE'],
  },
  colors: ['#fff', '#3182CE'],
};
